import { useState } from 'react'

import { downloadBlob } from '../api/client'
import { t } from '../i18n/lingua'
import { ErrorBanner } from './common'

/**
 * I due pulsanti «Esporta Excel» / «Esporta PDF» per una sezione tabellare.
 *
 * Una sola componente perché l'inventario software ha più sezioni che esportano
 * allo stesso modo (elenco, scadenze, licenze, application maintenance): due
 * copie della stessa logica di download divergerebbero alla prima correzione.
 * Il token d'autenticazione va in header, quindi si scarica con `downloadBlob`
 * e non con un `<a href>`.
 */
export function BottoniEsporta({
  path,
  nome,
  disabled,
}: {
  /** Costruisce il percorso dell'endpoint per il formato scelto. */
  path: (fmt: 'xlsx' | 'pdf') => string
  /** Nome del file scaricato, senza estensione. */
  nome: string
  disabled?: boolean
}) {
  const [scaricando, setScaricando] = useState<'xlsx' | 'pdf' | null>(null)
  const [errore, setErrore] = useState<unknown>(null)

  async function esporta(fmt: 'xlsx' | 'pdf') {
    setScaricando(fmt)
    setErrore(null)
    try {
      const blob = await downloadBlob(path(fmt))
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${nome}.${fmt}`
      a.click()
      URL.revokeObjectURL(url)
    } catch (e) {
      setErrore(e)
    } finally {
      setScaricando(null)
    }
  }

  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
      <button
        type="button"
        className="secondary"
        disabled={disabled || scaricando !== null}
        onClick={() => esporta('xlsx')}
      >
        {scaricando === 'xlsx' ? t('Esporto…') : t('Esporta Excel')}
      </button>
      <button
        type="button"
        className="secondary"
        disabled={disabled || scaricando !== null}
        onClick={() => esporta('pdf')}
      >
        {scaricando === 'pdf' ? t('Esporto…') : t('Esporta PDF')}
      </button>
      {Boolean(errore) && <ErrorBanner error={errore} />}
    </div>
  )
}
